import { Grid, Link, Typography } from '@material-ui/core';
import SummaryImage from '../summaryImage/SummaryImage';
import LinkRouter from '../../../../../../common/components/presentation/linkRouter/LinkRouter';
import { ROUTES } from '../../../../../../common/constants/routes';
import SummaryMinimalContainer from '../summaryMinimal/SummaryMinimalContainer';
import SummaryLinksContainer from '../summaryLinks/SummaryLinksContainer';
import React, { FC } from 'react';
import summaryPrimaryContentStyles from './summaryPrimaryContentStyles';
import CurrencySwitchContainer from '../currencySwitch/CurrencySwitchContainer';
import { routeUtils } from '../../../../../../common/utils/routeUtils';
import useStockUrl from '../../../../../react/navigation/useStockUrl';
import { useHistory } from 'react-router';
import useIsMobile from '../../../../../../common/react/useIsMobile';
import useIsTablet from '../../../../../../common/react/useIsTablet';
import usePlatformConfig from '../../../../../../common/react/usePlatformConfig';
import Translation from '../../../../../../common/components/translation/Translation';

interface ISummaryPrimaryContentProps {
  imageUrl: string;
  isComplexModel?: boolean;
}

const SummaryPrimaryContent: FC<ISummaryPrimaryContentProps> = ({ imageUrl, isComplexModel }) => {
  const isMobile = useIsMobile();
  const history = useHistory();
  const isTablet = useIsTablet();
  const styles = summaryPrimaryContentStyles();
  const { listUrl } = useStockUrl();
  const {
    platformConfig: { stockPage },
  } = usePlatformConfig();

  return (
    <>
      <Grid item={true}>
        <SummaryImage imageUrl={imageUrl} />
        {!isComplexModel && (
          <Typography variant={'helpingText'} component={'p'} align={'center'} className={styles.ctaLink}>
            <LinkRouter
              to={ROUTES.MODELS}
              underline={'always'}
              color={'secondary'}
              data-test={'configure:summary:toModels'}
            >
              <Translation id={'spc.customise.changeModel'} />
            </LinkRouter>
          </Typography>
        )}
        {stockPage && (isMobile || isTablet) && (
          <Typography variant={'helpingText'} component={'p'} align={'center'} className={styles.ctaLink}>
            <Link
              onClick={() => routeUtils.pushWithQueryParams(history, listUrl)}
              underline={'always'}
              color={'secondary'}
              data-test={'configure:summary:availableStock'}
            >
              <Translation id={'spc.stock.availableStock'} />
            </Link>
          </Typography>
        )}
      </Grid>
      <CurrencySwitchContainer />
      <Grid item={true} className={styles.pricesContainer}>
        <SummaryMinimalContainer />
      </Grid>
      <Grid item={true}>
        <SummaryLinksContainer />
      </Grid>
    </>
  );
};

export default SummaryPrimaryContent;
